import { UserExperienceDto } from '@apply/api/src/api/ApplyApi';
import { isMobileScreen } from '@apply/ui';

export const formatExperienceAddress = (e: UserExperienceDto) => {
    const mobile = isMobileScreen();

    const street = e.street2 ? `${e.street1} ${e.street2}` : e.street1;

    const cityStateZip = `${e.city}, ${e.state} ${e.zipCode}`;

    return (
        <>
            {street}
            {mobile && <br />}
            {!mobile && ', '}
            {cityStateZip}
        </>
    );
};
